export default __webpack_public_path__ + "static/long-bbfa748b5ddd7c570e592a6911eac3ea.png";